export default __webpack_public_path__ + "static/nike-cover-18e85651aa7d481b28a52558b3e38d34.mp4";